import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Router, NavigationStart, Event } from '@angular/router';

export interface ListRestorationType {
  values: Object;
  list: Object[];
  canLoadMore: boolean;
  manualLimit?: number;
  highlight?: Object;
  activeFilters?: any[];
  fullList?: Object[];
  listItemCount?: number;
  nonProfessionCount?: number;
  professionCount?: number;
}
@Injectable({
  providedIn: 'root',
})

export class ScrollRestorationService {
  public restorationValues = new BehaviorSubject<{ [type: string]: ListRestorationType }>(null);
  public restorationPosition = new BehaviorSubject<{ [type: string]: number }>(null);
  public routerSub: Subscription;
  public popstateNavigation: boolean;

  constructor(private router: Router) {
    this.routerSub = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.popstateNavigation = event.navigationTrigger === 'popstate';
      }
    });
  }
}
